import * as React from "react"
import "./image_and_blurb.scss"
import HandleHeroImage from "../hooks/handleHeroImage";

const ImageAndBlurb = ({ right, headline, headlineBold, paragraph, buttonText, buttonHref, image, boldBefore  }) => {
  let imageOrder, contentOrder;
  right === true ? imageOrder = 'order-2' : imageOrder = 'order-1'
  right !== true ? contentOrder = 'order-2' : contentOrder = 'order-1'

  // reduces padding to 0 in-case of floating-webpage-image present(ie homepage) 
  let paddingTopContainer;
  buttonText === 'Our Customer Stories' ? paddingTopContainer = ' pt-0' : paddingTopContainer = '';

  return (
    <section>
    <div id="image-and-blurb-container" className={"container image-and-blurb-container my-xl-3" + paddingTopContainer}>
      <div className={right === true ? 'image-right-row row row-cols-1 d-flex' : "row row-cols-1 d-flex"}>
        <div className={contentOrder + " col-md-12 col-lg-5 d-flex flex-column justify-content-md-center"}>
          <article>
          {/* <Headline regular={headline} bold={headlineBold} /> */}
          {/* <h2 className="pt-3">{headline} <strong>{headlineBold}</strong></h2> */}
          <h2 className="pt-3">
          {boldBefore 
            ? <><strong>{headlineBold}</strong> {headline}</> 
            : <>{headline} <strong>{headlineBold}</strong></>}
          </h2>
          {/* <Caption text={paragraph} /> */}
          <p className="py-2 caption">{paragraph}</p>
          {/* <BlueCTAButton text={buttonText} href={buttonHref} /> */}
          {buttonText? <a href={buttonHref}><button className="bg-primary blue-cta-button p-2 px-4 mt-2">{buttonText}</button></a> : null}
          </article>
        </div>
        <div className={imageOrder + " col-md-12 col-lg-7"}>
          <HandleHeroImage imageName={image}/>
        </div>
      </div>
    </div>
    </section>
  )
}

export default ImageAndBlurb